import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getAppVersion } from '@/tool';

Vue.use(VueI18n)

import AR from './AR'
import DE from './DE'
import EN from './EN'
import ES from './ES'
import FR from './FR'
import ID from './ID'
import IT from './IT'
import JA from './JA'
import KO from './KO'
import NL from './NL'
import PL from './PL'
import PT from './PT'
import RU from './RU'
import TH from './TH'
import TR from './TR'
import VI from './VI'
import zhHant from './zh-Hant'
import zhHants from './zh-Hans'

export default new VueI18n({
  locale: getAppVersion() === "ZH" ? 'zh-Hants' : 'EN',
  messages: {
    AR,
    DE,
    ES,
    FR,
    ID,
    IT,
    JA,
    KO,
    NL,
    PL,
    PT,
    RU,
    TH,
    TR,
    VI,
    EN,
    'zh-Hans': zhHants,
    'zh-Hant': zhHant
  }
})



// WEBPACK FOOTER //
// ./src/lang/index.js